/// <reference path='../../interfaces/interfaces.d.ts' />

'use strict';

class Numberv1Config {

    constructor (private schemaFormProvider: any,
                 private schemaFormDecoratorsProvider: any,
                 private sfPathProvider: any) {

        let numberv1: any = function(name: any, schema: any, options: any): any {
            var f: any;

            if ((schema.type === 'number' || schema.type === 'integer') && !schema.enum) {
                f = schemaFormProvider.stdFormObj(name, schema, options);
                f.key  = options.path;
                f.type = 'number';
                options.lookup[sfPathProvider.stringify(options.path)] = f;
                return f;
            }
        };

        schemaFormProvider.defaults.number.unshift(numberv1);
        schemaFormProvider.defaults.integer.unshift(numberv1);
        schemaFormDecoratorsProvider.addMapping(
            'bootstrapDecorator',
            'number',
            'numberv1.html'
        );
    }

    public static configure(schemaFormProvider: any, schemaFormDecoratorsProvider: any, sfPathProvider: any): Numberv1Config {
        return new Numberv1Config(schemaFormProvider, schemaFormDecoratorsProvider, sfPathProvider);
    }
}

Numberv1Config.configure.$inject = [
    'schemaFormProvider',
    'schemaFormDecoratorsProvider',
    'sfPathProvider'
];

class Numberv1Run {
    constructor ($templateCache: angular.ITemplateCacheService) {
        $templateCache.put('numberv1.html', `
            <div class="form-group schema-form-{{form.type}} {{form.htmlClass}}" ng-class="{\'has-error\': form.disableErrorState !== true && hasError(), \'has-success\': form.disableSuccessState !== true && hasSuccess(), \'has-feedback\': form.feedback !== false, \'required-field\': form.required}">
                <div class="row">
                    <div class="col-sm-4">
                        <label class="control-label {{form.labelHtmlClass}}" ng-class="{\'sr-only\': !showTitle()}" for="{{form.key.slice(-1)[0]}}">{{form.title}}</label>
                    </div>

                    <div class="col-sm-6">
                        <input ng-if="!form.required && !form.fieldAddonLeft && !form.fieldAddonRight" ng-show="form.key" type="{{form.type}}" step="any" sf-changed="form" placeholder="{{form.placeholder}}" class="form-control {{form.fieldHtmlClass}}" id="{{form.key.slice(-1)[0]}}" ng-model-options="form.ngModelOptions" ng-model="$$value$$" ng-disabled="form.readonly" schema-validate="form" name="{{form.key.slice(-1)[0]}}" aria-describedby="{{form.key.slice(-1)[0] + \'Status\'}}">
                        <input ng-if="form.required && !form.fieldAddonLeft && !form.fieldAddonRight" required ng-show="form.key" type="{{form.type}}" step="any" sf-changed="form" placeholder="{{form.placeholder}}" class="form-control {{form.fieldHtmlClass}}" id="{{form.key.slice(-1)[0]}}" ng-model-options="form.ngModelOptions" ng-model="$$value$$" ng-disabled="form.readonly" schema-validate="form" name="{{form.key.slice(-1)[0]}}" aria-describedby="{{form.key.slice(-1)[0] + \'Status\'}}">

                        <span class="material-input"></span>

                        <div ng-if="form.fieldAddonLeft || form.fieldAddonRight" ng-class="{\'input-group\': (form.fieldAddonLeft || form.fieldAddonRight)}">
                            <span ng-if="form.fieldAddonLeft" class="input-group-addon" ng-bind-html="form.fieldAddonLeft"></span>
                            <input ng-show="form.key" type="{{form.type}}" step="any" sf-changed="form" placeholder="{{form.placeholder}}" class="form-control {{form.fieldHtmlClass}}" id="{{form.key.slice(-1)[0]}}" ng-model-options="form.ngModelOptions" ng-model="$$value$$" ng-disabled="form.readonly" schema-validate="form" name="{{form.key.slice(-1)[0]}}" aria-describedby="{{form.key.slice(-1)[0] + \'Status\'}}">
                            <span ng-if="form.fieldAddonRight" class="input-group-addon" ng-bind-html="form.fieldAddonRight"></span>
                        </div>

                        <span ng-if="form.feedback !== false" class="form-control-feedback" ng-class="evalInScope(form.feedback) || {\'glyphicon\': true, \'glyphicon-ok\': hasSuccess(), \'glyphicon-remove\': hasError() }" aria-hidden="true"></span>
                        <span ng-if="hasError() || hasSuccess()" id="{{form.key.slice(-1)[0] + \'Status\'}}" class="sr-only">{{ hasSuccess() ? \'(success)\' : \'(error)\' }}</span>

                        <div ng-if="form.required" class="empty-field">You can't leave this empty.</div>
                    </div>
                </div>
            </div>
        `);
    }

    public static run($templateCache: angular.ITemplateCacheService): Numberv1Run {
        return new Numberv1Run($templateCache);
    }
}

Numberv1Run.$inject = ['$templateCache'];

angular.module('schemaForm').config(Numberv1Config.configure).run(Numberv1Run.run);



// WEBPACK FOOTER //
// ./frontend/scripts/schemaForm/configs/number_v1.config.ts